/* ICONS */
import { MdSpaceDashboard, MdLockReset } from "react-icons/md";
import { IoBagHandle } from "react-icons/io5";
import { FaHeart, FaCoins } from "react-icons/fa6";
import { FaBook } from "react-icons/fa";
import { RiCoupon2Fill } from "react-icons/ri";

const dashboardTabs = [
  {
    id: 1,
    key: "dashboard",
    icon: <MdSpaceDashboard className="w-5 h-5 text-black" />,
    value: "dashboard",
    label: "Dashboard",
  },
  {
    id: 2,
    key: "reset-password",
    icon: <MdLockReset className="w-5 h-5 text-black" />,
    value: "reset-password",
    label: "Change Password",
  },
  {
    id: 3,
    key: "my-orders",
    icon: <IoBagHandle className="w-5 h-5 text-black" />,
    value: "my-orders",
    label: "My orders",
  },
  {
    id: 4,
    key: "my-wishlist",
    icon: <FaHeart className="w-5 h-5 text-black" />,
    value: "my-wishlist",
    label: "My wishlist",
  },
  {
    id: 5,
    key: "address-book",
    icon: <FaBook className="w-5 h-5 text-black" />,
    value: "address-book",
    label: "Address book",
  },
  {
    id: 6,
    key: "loyalty-program",
    icon: <FaCoins className="w-5 h-5 text-black" />,
    value: "loyalty-program",
    label: "Loyalty program",
  },
  {
    id: 7,
    key: "coupon-codes",
    icon: <RiCoupon2Fill className="w-5 h-5 text-black" />,
    value: "coupon-codes",
    label: "Coupon codes",
  },
];

const sampleOrders = [
  {
    orderID: "#OTJRQEYD",
    orderDate: "Nov 08, 2023",
    productName: "Blue Diamond Almonds Lightly Salted",
    amount: "₹3,499.00",
    status: "Delivered",
  },
  {
    orderID: "#474XD4FG",
    orderDate: "Nov 08, 2023",
    productName: "Real Plant Powered Protein Shake",
    amount: "₹2,499.00",
    status: "In transit",
  },
  {
    orderID: "#OTJRQEYD",
    orderDate: "Nov 08, 2023",
    productName: "Great Value Rising Crust Frozen Pizza",
    amount: "₹6,499.00",
    status: "Order shipped",
  },
];

const sampleActivity = [
  {
    couponCode: "474XD4FG",
    orderDate: "Nov 08, 2023",
    productName: "Lamborghini - 1:18 DIe-cast Car by Maisto",
    pointsSpent: "100",
    type: "DEBIT",
  },
];

const couponCodes = [
  {
    couponCode: "474XD4FG",
    discount: "₹3,499.00",
    date: "Nov 08, 2023",
  },
];

export { dashboardTabs, sampleOrders, sampleActivity, couponCodes };
